// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import ProductCategoryModel from '../../model/product-category-model';
import ProductCategoryDTO from '../dto/product-category-dto';
import ResourceLinkModel from '../../model/resource-link-model';

export default abstract class ProductCategoryModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<ProductCategoryDTO>) {
    super();
    if (data) {
      this.id = data.id;
      this.links = data.links?.map((i) => ResourceLinkModel.toModel(i)) ?? [];
      this.creatorId = data.creatorId;
      this.creatorName = data.creatorName ?? undefined;
      this.created = data.created;
      this.modifierId = data.modifierId ?? undefined;
      this.modifierName = data.modifierName ?? undefined;
      this.modified = data.modified ?? undefined;
      this.title = data.title ?? undefined;
      this.isRoot = data.isRoot;
      this.subCategories = data.subCategories?.map((i) => ProductCategoryModel.toModel(i)) ?? [];
      this.productIds = data.productIds ?? undefined;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;
  /**
  */
  'links'?: ResourceLinkModel[];
  /**
  * @type {int64}
  */
  'creatorId'?: number;
  /**
  */
  'creatorName'?: string;
  /**
  * @type {date-time}
  */
  'created'?: string;
  /**
  * @type {int64}
  */
  'modifierId'?: number;
  /**
  */
  'modifierName'?: string;
  /**
  * @type {date-time}
  */
  'modified'?: string;
  /**
  */
  'title'?: string;
  /**
  */
  'isRoot'?: boolean;
  /**
  */
  'subCategories'?: ProductCategoryModel[];
  /**
  */
  'productIds'?: number[];

  static toModel(dto: DeepPartial<ProductCategoryDTO>): ProductCategoryModel;
  static toModel(dto: DeepPartial<ProductCategoryDTO> | undefined | null): ProductCategoryModel | undefined;
  static toModel(dto: DeepPartial<ProductCategoryDTO> | undefined | null): ProductCategoryModel | undefined {
    return dto ? new ProductCategoryModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<ProductCategoryModel> | ProductCategoryModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
      'links': unwrapped.links,
      'creatorId': unwrapped.creatorId,
      'creatorName': unwrapped.creatorName,
      'created': unwrapped.created,
      'modifierId': unwrapped.modifierId,
      'modifierName': unwrapped.modifierName,
      'modified': unwrapped.modified,
      'title': unwrapped.title,
      'isRoot': unwrapped.isRoot,
      'subCategories': unwrapped.subCategories,
      'productIds': unwrapped.productIds,
    } as ProductCategoryDTO;
  }
}
